import InputLabel from './InputLabel';
export default InputLabel;
//# sourceMappingURL=index.js.map